import { render } from "./PShopDesc.vue?vue&type=template&id=7581a6ef"
import script from "./PShopDesc.vue?vue&type=script&lang=js"
export * from "./PShopDesc.vue?vue&type=script&lang=js"

import "./PShopDesc.vue?vue&type=style&index=0&id=7581a6ef&lang=css"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__